import type { Enrollment } from '../lib/api';
import { fmtTime } from '../lib/format';
import { CopyField } from './ui';

/** Shown once after creating a device or a new code. */
export function EnrollmentCode({ enrollment, timezone }: { enrollment: Enrollment; timezone: string }) {
  return (
    <div className="space-y-3 text-sm">
      <div>
        <div className="mb-1 font-medium">Enrollment code</div>
        <CopyField value={enrollment.code} label="Enrollment code" />
        <p className="mt-1 text-xs text-muted">Shown only now. Works once, until {fmtTime(enrollment.expiresAt, timezone)}.</p>
      </div>
      <div>
        <div className="mb-1 font-medium">On the IPC</div>
        <p className="mb-1 text-xs text-muted">PowerShell as Administrator, in the vardex release folder. If vardex isn't deployed yet, use deploy.ps1 with -CloudUrl and -SyncCode instead.</p>
        <CopyField value={enrollment.commands.ipc} label="IPC command" />
      </div>
      <div>
        <div className="mb-1 font-medium">On a developer PC</div>
        <CopyField value={enrollment.commands.developer} label="Developer command" />
      </div>
    </div>
  );
}
